import {
  BASE_URL, 
  POST,  
  COMMENT,
  GET,
  PAGE_SIZE,
  DEMAND
} from "../constants";
import { statusParsing, jsonParsing } from "../utils";
import { getAccessToken } from "../../authActions/authActions";

export const addCommentRequest = async (payload,id) => {
  const token = await getAccessToken();
  const resource = `${BASE_URL}${DEMAND}/${id}/${"comment"}`;
  return fetch(resource, {
    method: POST,
    headers: {
      "Content-Type": "application/json",
      "userauth": `Bearer ${token}`
    },
    body: JSON.stringify(payload)
  })
    .then(statusParsing)
    .then(jsonParsing);
};


export const fetchComments = async (requestId,next,pageSize=PAGE_SIZE) => {
  const token = await getAccessToken();    
  let url = `${BASE_URL}${DEMAND}/${requestId}/${"volte-comments"}`;   
  if(next){
    url=`${url}?next=${next}`
  }
  if(pageSize){
    url=`${url}?pageSize=${pageSize}`
  }
  return fetch(url, {
      method: GET,
      headers: {
        "Content-Type": "application/json",
        "userauth" : `bearer ${token}`
      },
    })
    .then(statusParsing)
    .then(jsonParsing);   

};